import { HEX_COLORS as r } from "@partoohub/branding";
const u = (t, e) => {
  if (t === "contained") {
    const o = e === "white" ? r.blackberry : "white";
    return e === "theme" ? "theme" : o;
  }
  return e === "theme" ? "default" : e === "secondary" ? t === "text" ? "secondary" : "default" : e;
};
export {
  u as getColorText
};
